import { XANO, AIRTABEL, SUPABASE, REST_API } from 'drapcode-constant';
export const DEFAULT = 'DEFAULT';
export const FIREBASE = 'FIREBASE';
export const FIRESTORE = 'FIRESTORE';
export const NOTION = 'NOTION';
export const APPWRITE = 'APPWRITE';

export const sourceOfCollectionOptions = [
  { value: DEFAULT, label: 'Default', icon: 'database' },
  { value: REST_API, label: 'REST API', icon: 'paper-plane' },
  { value: XANO, label: 'Xano', icon: 'paper-plane' },
];

export const DEFAULT_COLLECTION_FILTERS = [
  'Find All',
  'All Items',
  'All Items Count',
  'All Items Created By Current LoggedIn User',
  'All Items Created By Current LoggedIn User Count',
];

export const DEFAULT_TENANT_COLLECTION_FILTERS = [
  'All Items of Current LoggedIn User Tenant',
  'All Items of Current LoggedIn User Tenant Count',
];

export const DEFAULT_SUB_TENANT_COLLECTION_FILTERS = [
  'All Items of Current LoggedIn User Sub Tenant',
  'All Items of Current LoggedIn User Sub Tenant Count',
];
export const DEFAULT_COLLECTION_CONSTRUCTORS = ['Default Constructor'];

export const getValuesForDefaultField = (values) => {
  const { extraFieldSetting } = values || {};
  if (!extraFieldSetting) return '';
  const { defaultValue } = extraFieldSetting;
  return defaultValue !== undefined && defaultValue !== null ? defaultValue : '';
};
